import { render, staticRenderFns } from "./hikvision-video.vue?vue&type=template&id=703649e0&scoped=true"
import script from "./hikvision-video.vue?vue&type=script&lang=js"
export * from "./hikvision-video.vue?vue&type=script&lang=js"
import style0 from "./hikvision-video.vue?vue&type=style&index=0&id=703649e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703649e0",
  null
  
)

export default component.exports